<div class="one" [formGroup]="SettingForm" fxLayout="column">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-4 gap-y-4">
    <mat-form-field
      appearance="outline"
      class="trust-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FIRSTTRUSTMONTH),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FIRSTTRUSTMONTH),
      }"
    >
      <mat-label>First Trust Month</mat-label>
      <mat-select
        name="FIRSTTRUSTMONTH"
        formControlName="FIRSTTRUSTMONTH"
        placeholder="First Trust Month"
        disabled
      >
        @for (val of getDropDownValue.FIRSTTRUSTMONTH; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="trust-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTSTATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTSTATE),
      }"
    >
      <mat-label>Trust State</mat-label>
      <mat-select name="TRUSTSTATE" formControlName="TRUSTSTATE" placeholder="Trust State">
        @for (val of getDropDownValue.TRUSTSTATE; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">{{ val.DESCRIPTION }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="trust-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTTRUSTRECEIPTTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEFAULTTRUSTRECEIPTTYPE),
      }"
    >
      <mat-label>Default Trust Receipt Type</mat-label>
      <mat-select
        name="DEFAULTTRUSTRECEIPTTYPE"
        formControlName="DEFAULTTRUSTRECEIPTTYPE"
        placeholder="Default Receipt Type"
      >
        @for (val of getDropDownValue.DEFAULTTRUSTRECEIPTTYPE; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-3 gap-y-4">
    <mat-form-field
      appearance="outline"
      class="trust-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTTRUSTWITHDRAWALTYPE),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.DEFAULTTRUSTWITHDRAWALTYPE
        ),
      }"
    >
      <mat-label>Default Trust Withdrawal Type</mat-label>
      <mat-select
        name="DEFAULTTRUSTWITHDRAWALTYPE"
        formControlName="DEFAULTTRUSTWITHDRAWALTYPE"
        placeholder="Default Withdrawal Type"
      >
        @for (val of getDropDownValue.DEFAULTTRUSTWITHDRAWALTYPE; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="trust-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTCHEQUEFORMAT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTCHEQUEFORMAT),
      }"
    >
      <mat-label>Trust Cheque Format</mat-label>
      <mat-select
        name="TRUSTCHEQUEFORMAT"
        formControlName="TRUSTCHEQUEFORMAT"
        placeholder="Trust Cheque"
      >
        @for (val of getDropDownValue.TRUSTCHEQUEFORMAT; track val) {
          <mat-option value="{{ val.DESCRIPTION }}">
            {{ val.DESCRIPTION }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="trust-input pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTRECEIPTCOPIES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTRECEIPTCOPIES),
      }"
    >
      <mat-label>Trust Receipt Copies</mat-label>
      <mat-select
        name="TRUSTRECEIPTCOPIES"
        formControlName="TRUSTRECEIPTCOPIES"
        placeholder="Trust Receipt Copies"
      >
        <mat-option value="1">1</mat-option>
        <mat-option value="2">2</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div
    class="check bold-text mb-3 text-[14px] font-semibold"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxFlex="1 0 auto"
  >
    Please enter the account details of your trust account.
  </div>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-3 gap-y-4">
    <mat-form-field
      appearance="outline"
      class="trust-input-3 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTACCACCOUNTNAME),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTACCACCOUNTNAME),
      }"
    >
      <mat-label>Account Name</mat-label>
      <input name="TRUSTACCACCOUNTNAME" formControlName="TRUSTACCACCOUNTNAME" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="trust-input-2 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTACCBSB),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTACCBSB),
      }"
    >
      <mat-label>BSB</mat-label>
      <input name="TRUSTACCBSB" formControlName="TRUSTACCBSB" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="trust-input-2 pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTACCACCOUNTNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTACCACCOUNTNUMBER),
      }"
    >
      <mat-label>A/C No</mat-label>
      <input name="TRUSTACCACCOUNTNUMBER" formControlName="TRUSTACCACCOUNTNUMBER" matInput />
      <mat-icon matSuffix class="secondary-text"></mat-icon>
    </mat-form-field>
  </div>

  @if (currentUser?.PRODUCTTYPE == 'Solicitor') {
    <div
      class="check bold-text mb-3 text-[14px] font-semibold"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxFlex="1 0 auto"
    >
      Initial Trust Value
    </div>
  }
  @if (currentUser?.PRODUCTTYPE == 'Solicitor') {
    <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-3 gap-y-4">
      <mat-form-field
        appearance="outline"
        class="trust-input-2 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTFIRSTRECEIPTCODE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTFIRSTRECEIPTCODE),
        }"
      >
        <mat-label>First Recipt Code</mat-label>
        <input name="TRUSTFIRSTRECEIPTCODE" formControlName="TRUSTFIRSTRECEIPTCODE" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="trust-input-2 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTFIRSTWITHDRAWALCODE),
          'has-warning': $safeNavigationMigration(
            errorWarningData.Warning?.TRUSTFIRSTWITHDRAWALCODE
          ),
        }"
      >
        <mat-label>First Withdrawal Code</mat-label>
        <input
          name="TRUSTFIRSTWITHDRAWALCODE"
          formControlName="TRUSTFIRSTWITHDRAWALCODE"
          matInput
        />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="trust-input-2 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTFIRSTTRANSFERCODE),
          'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TRUSTFIRSTTRANSFERCODE),
        }"
      >
        <mat-label>First Transfer Code</mat-label>
        <input name="TRUSTFIRSTTRANSFERCODE" formControlName="TRUSTFIRSTTRANSFERCODE" matInput />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        class="trust-input-2 pr-1"
        [ngClass]="{
          'has-error': $safeNavigationMigration(errorWarningData.Error?.TRUSTFIRSTWITHDRAWALEFTID),
          'has-warning': $safeNavigationMigration(
            errorWarningData.Warning?.TRUSTFIRSTWITHDRAWALEFTID
          ),
        }"
      >
        <mat-label>First Withdrawal EFT ID</mat-label>
        <input
          name="TRUSTFIRSTWITHDRAWALEFTID"
          formControlName="TRUSTFIRSTWITHDRAWALEFTID"
          matInput
        />
        <mat-icon matSuffix class="secondary-text"></mat-icon>
      </mat-form-field>
    </div>
  }
  @if (currentUser?.PRODUCTTYPE == 'Solicitor') {
    <div
      class="check bold-text mb-3 text-[14px] font-semibold"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxFlex="1 0 auto"
      style="color: gray"
    >
      Note: First codes only take effect for the first transaction entered into the system.
    </div>
  }

  <div class="pt-4">
    <mat-dialog-actions class="popup_ftr justify-end!">
      <button
        id="callApiId"
        class="mainbtn_size"
        matButton="filled"
        [disabled]="isspiner"
        (click)="saveTrust()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Save
      </button>
      <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
    </mat-dialog-actions>
  </div>
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
            </div> -->
  <!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">


          </div> -->
</div>
